import { X } from 'lucide-react';

/**
 * Tombol silang untuk mengosongkan kotak pencarian dengan sekali tekan.
 *
 * Dulu, mengganti kata yang dicari berarti menahan Backspace sampai habis —
 * puluhan kali sehari. Tombol ini muncul hanya ketika kotaknya ada isinya.
 *
 * Syarat pemakaian:
 *   - pembungkus input harus punya kelas "relative"
 *   - input diberi padding kanan (pr-9) supaya tulisannya tidak tertimpa
 */
export function HapusCari({ show, onClear, testid }) {
  if (!show) return null;
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onClear}
      title="Hapus pencarian"
      aria-label="Hapus pencarian"
      className="absolute right-2.5 top-1/2 -translate-y-1/2 p-1 rounded-full text-mocha hover:bg-brown/10 hover:text-brown transition-colors"
    >
      <X size={15} />
    </button>
  );
}
